import { opBNB as viemOpBNB } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const opBNB = {
  displayName: 'opBNB',
  runtime: 'evm',
  viemChain: viemOpBNB,
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 'opbnb' },
    pimlico: { chainSlug: 'opbnb' },
  }),
} as const satisfies AllChainConfig<'evm', false>;
